module.exports = __webpack_public_path__ + "img/chr_ts_12_penlight.2a98cc33.png";